"use client";

import { useEffect } from "react";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return (
        <div className="bg-neutral-200/80 dark:bg-neutral-800/80 w-full min-h-[90vh] flex flex-col items-center justify-center gap-5">
            <h2 className="text-xl">Oops！出現了問題！</h2>
            <button
                onClick={() => reset()}
                className="p-2 rounded bg-primary hover:scale-105 transition-normal text-neutral-100"
            >
                重新整理
            </button>

            <hr className="border w-full max-w-[50vw] border-neutral-700" />

            <pre className="p-2 text-sm rounded bg-secondary/80 text-neutral-400 dark:text-neutral-500">
                Error Digest: {error.digest}
            </pre>
        </div>
    );
}
